import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  progress: {
    margin: theme.spacing(2),
    width: '50px !important',
    height: '50px !important',
  },
  loadingHeader: {
    margin: theme.spacing(2),
    width: '40px !important',
    height: '40px !important',
    color: '#fff',
  },
  loadingDebits: {
    margin: theme.spacing(2),
    width: '30px !important',
    height: '30px !important',
  }
}));

export default function LoadingDefault(props) {
  const classes = useStyles();

  return (
    <div>
      <CircularProgress
        className={`
          ${props.typeLoading === 'header' && classes.loadingHeader}
          ${props.typeLoading === 'card' && classes.progress}
          ${props.typeLoading === 'debits' && classes.loadingDebits}
        `} />
    </div>
  );
}